import type { Configuration, QueryCostDataRequest } from '@repo/api-gw-sdk';
import { BillingApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/metering';

export const metering = (httpClient: HttpClient, config: Configuration) => {
  const billingApi = new BillingApi(config);

  return {
    useQueryCostData: (queryCostDataRequest: QueryCostDataRequest) =>
      httpClient.execute(
        billingApi.queryCostData.bind(billingApi),
        baseUrl,
        '',
        queryCostDataRequest
      ),
    useGetBillingTransactions: (startTime: Date, endTime: Date) =>
      httpClient.execute(
        billingApi.getBillingTransactionsWithPreview.bind(billingApi),
        baseUrl,
        '/billing-transactions',
        startTime,
        endTime
      ),
    useGetAgreements: () =>
      httpClient.execute(
        billingApi.getAgreements.bind(billingApi),
        baseUrl,
        '/agreements'
      ),
  };
};
